module.exports = __webpack_public_path__ + "img/unlike.1ba28928.png";